import React from 'react';
import PropTypes from 'prop-types';
import CustomReactMarkdown from '../../../MarkdownRenderers/CustomReactMarkdown';
import CategoryTag from '../../../CategoryTag/CategoryTag';


const CategoryTemplate = function CategoryTemplateComponent({
  title,
  subtitle,
  image,
  coBranding,
  imageAltText,
}) {
  const { tagline, imageUrl, isEnabled: coBrandingEnabled } = coBranding;

  return (
    <div className="search-banner__wrapper">
      <div className="se-container">
        <div className="search-banner__text">
          <h1 className="search-banner__title">{title}</h1>
          <CustomReactMarkdown className="search-banner__description" source={subtitle} />
        </div>
      </div>
      {coBrandingEnabled && (
        <CategoryTag tagline={tagline} imageUrl={imageUrl} />
      )}
      <div className="search-banner__image--wrapper">
        <img className="search-banner__image" src={image} alt={imageAltText || ''} />
      </div>
    </div>
  );
};

CategoryTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  coBranding: PropTypes.shape({
    tagline: PropTypes.string,
    imageUrl: PropTypes.string,
    isEnabled: PropTypes.bool,
  }),
  imageAltText: PropTypes.string,
};

CategoryTemplate.defaultProps = {
  coBranding: PropTypes.shape({
    tagline: '',
    imageUrl: '',
    isEnabled: false,
  }),
  imageAltText: '',
};

export default CategoryTemplate;
